module.exports = __webpack_public_path__ + "img/Mask-Group.fe31df10.png";